import { withAuthenticationRequired } from "@auth0/auth0-react"; 
import React from "react";
import FormularioClasificacion from "../../components/clasificacion/FormularioClasificacion";

const Clasificacion: React.FC = () => {
    return (
        <div>
            <FormularioClasificacion />
        </div>
    );
};

export default withAuthenticationRequired(Clasificacion);
